export const apiUrl = "https://mahakalyatra.com/admin/api/";
export const imageUrl = "https://mahakalyatra.com/admin/storage/app/public/";

// export const apiUrl = "http://127.0.0.1:8000/api/";
// export const imageUrl = "http://127.0.0.1:8000/storage/app/public/";
